<template>
  <div>
    <el-form class="demo-ruleForm" ref="macForm" :model="macForm">
      <div class="form-box" v-for="(macList,index) in macForm.macList" :key="'m'+index">
        <el-row>
          <el-col :span="6">
            <el-form-item :prop="'macList.' + index + '.beginMac'" :rules="rules.beginMac">
              <el-input v-model="macList.beginMac" :disabled="disabled" placeholder="请输入定投mac地址"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-button style="margin-left:10px" @click="handleDelete(index)" v-if="!disabled">删除</el-button>
            <el-button @click="handleAdd" v-if="!disabled">添加</el-button>
          </el-col>
        </el-row>
      </div>
       <el-button type="text" v-if="!disabled" @click="handleSelectFormTag">从标签库选择</el-button>
    </el-form>
    <el-dialog title="查询筛选" :visible.sync="dialogVisible" width="70%">
       <Table
        :props="table.props"
        :header="table.header"
        :data="table.data"
        :selected="table.selected"
        :selection-type="table.selectionType"
        @row-selection-add="handleRowSelectionAdd"
        @row-selection-remove="handleRowSelectionRemove"
        @all-row-selection-change="handleAllRowSelectionChange"
      />
      <pagination
        v-bind:currentpage="currentPage"
        v-bind:pagesize="pageSize"
        v-bind:totalcount="totalCount"
        @handle-size-change="handleSizeChange"
        @handle-current-change="handleCurrentChange"
      ></pagination>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Array
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      macForm: {
        macList: this.value
      },
      rules: {
        beginMac: [
          {
            validator: (rule, value, callback) => {
              if (value !== undefined) {
                if (
                  /^[a-fA-F0-9]{12,12}$/i.test(value) ||
                  /^([0-9]{4}(_))([0-9a-fA-F]{2})(([0-9a-fA-F]{2}){5})$/.test(value) ||
                  /^([0-9a-fA-F]{2})(([0-9a-fA-F]{2}){5})$/.test(value)
                ) {
                  callback()
                } else {
                  callback(new Error('mac地址填写错误'))
                }
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      },
      dialogVisible: false,
      pageSize: 10,
      // 当前页码:pageNum
      currentPage: 1,
      totalCount: 1,
      filter: {},
      table: {
        props: {
          border: true,
          stripe: false,
          'tooltip-effect': 'dark',
          'max-height': 590
        },
        header: [
          {
            label: 'ID',
            prop: 'testTagId',
            align: 'right',
            'min-width': '30'
          },
          {
            label: '标签名称',
            prop: 'testTagName',
            align: 'left',
            'min-width': '100'
          },
          {
            label: '创建人',
            prop: 'createBy',
            align: 'left',
            'min-width': '100'
          }
        ],
        data: [],
        selected: [],
        selectionType: 'multiple'
      },
      selected: [],
      selectedRow: []
    }
  },
  watch: {
    value(newValue, oldValue) {
      this.macForm.macList = newValue
    }
  },
  methods: {
    handleSelectFormTag() {
      this.dialogVisible = true
      this.pageSize = 10
      this.currentPage = 1
      this.selectedRow = []
      this.selected = []
      this.table.selected = []
      this.fetchData()
    },
    handleDelete(index) {
      if (this.macForm.macList.length === 1) {
        this.macForm.macList[0].beginMac = undefined
        this.macForm.macList[0].endMac = undefined
      } else {
        this.macForm.macList.splice(index, 1)
      }
    },
    handleAdd() {
      this.macForm.macList.push({
        beginMac: undefined,
        endMac: undefined
      })
    },
    handleConfirm() {
      let selectTableData = []
      const macReg = /^([0-9]{4}(_))([0-9a-fA-F]{2})(([0-9a-fA-F]{2}){5})$/
      this.selectedRow.forEach(item => {
        item.adTestMacEntityList.forEach(element => {
          let beginMac = element.beginMac
          let endMac = element.endMac
          if (macReg.test(beginMac) && macReg.test(endMac)) {
            const beginMacs = beginMac.split('_')
            if (beginMacs[0] === '1002' || beginMacs[0] === '1003') {
              beginMac = beginMacs[1]
            }
            const endMacs = endMac.split('_')
            if (endMacs[0] === '1002' || endMacs[0] === '1003') {
              endMac = endMacs[1]
            }
          }
          selectTableData.push({
            beginMac: beginMac,
            endMac: endMac
          })
        })
      })
      this.macForm.macList = this.macForm.macList.filter(item => item.beginMac && item.endMac).concat(selectTableData)
      if (this.macForm.macList.length === 0) {
        this.macForm.macList.push({
          beginMac: undefined,
          endMac: undefined
        })
      }
      this.handleUnique()
      this.dialogVisible = false
    },
    handleUnique() {
      const obj = {}
      const macList = this.macForm.macList
      this.macForm.macList = macList.reduce((item, next) => {
        // eslint-disable-next-line
        obj[next.beginMac] ? '' : obj[next.beginMac] = true && item.push(next)
        return item
      }, [])
      this.$emit('input', this.macForm.macList)
    },
    fetchData() {
      this.filter.pageSize = this.pageSize
      this.filter.pageNo = this.currentPage
      this.$service.getMacPageList(this.filter).then((data) => {
        this.table.data = data.rows
        this.totalCount = data.total
        this.updateTableSelected()
      })
    },
    // 每页显示数据量 变更, 如每页显示10条变成每页显示20时,val=20
    handleSizeChange: function (val) {
      this.pageSize = val
      this.fetchData()
    },
    // 页码变更, 如第1页变成第2页时,val=2
    handleCurrentChange: function (val) {
      this.currentPage = val
      this.fetchData()
    },
    handleRowSelectionAdd(targetItem) {
      this.selected.push(targetItem.testTagId)
      this.selectedRow.push(targetItem)
      this.updateTableSelected()
    },
    handleRowSelectionRemove(targetItem) {
      this.selected = this.selected.filter(item => {
        return item !== targetItem.testTagId
      })
      this.selectedRow = this.selectedRow.filter(item => {
        return item.testTagId !== targetItem.testTagId
      })
      this.updateTableSelected()
    },
    updateTableSelected() {
      const table = this.table
      const newSelectedIndex = this.selected
      this.selectedRow = []
      table.selected = table.data.reduce((result, item, index) => {
        if (newSelectedIndex.indexOf(item.testTagId) > -1) {
          this.selectedRow.push(item)
          result.push(index)
        }
        return result
      }, [])
    },
    handleAllRowSelectionChange(value) {
      if (value) {
        this.table.data.forEach(this.handleRowSelectionAdd)
      } else {
        this.selected = []
        this.selectedRow = []
        this.table.selected = []
      }
    },
    handleAllRowSelectionRemove() {
      this.selected = []
      this.selectedRow = []
      this.table.selected = []
    }
  },
  created() {

  }
}
</script>
<style lang="stylus" scoped>
>>>.el-dialog__body {
  padding: 0 20px;
}

.demo-ruleForm {
  .form-box {
    margin-bottom: 16px;
  }
}
</style>
